import { createSlice } from "@reduxjs/toolkit";
import { getCampaignSummary, getCount } from "../thunks/campaignThunks";
import { toast } from "react-toastify";

const initialState = {
    isLoading: true,
    error: null,
    counts:[],
    campaignsummary: null,
    campaignSummaryTableData: [],
};

const algorithmCampaign = createSlice({
    name: 'algorithmCampaign',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
        .addCase(getCount.fulfilled, (state,action) => {
            state.counts= action.payload?.results || [];
            state.error = null;
            state.isLoading = false;
        })
        .addCase(getCount.pending, (state, action) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(getCount.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
            toast.error(action.payload)
        })
        .addCase(getCampaignSummary.fulfilled, (state,action) => {
            state.campaignsummary= action.payload?.result?.data || null;
            state.error = null;
            state.isLoading = false;
        })
        .addCase(getCampaignSummary.pending, (state, action) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(getCampaignSummary.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
            toast.error(action.payload)
        })
        
    }
});

export const createDecileData = (decile, decile_count) => {
   
    if (decile) {
        return decile.map(dec => ({
            id: dec.id,
            decile: dec.decile,
            physician_qty: (decile_count && decile_count[dec.decile]) || 0,
            importance: dec.importance
        }));
    }
    return [];
};

export const createSegmentData = (segment, segment_count) => {
        if (segment) {
        return segment.map(seg => ({
            id: seg.id,
            segment: seg.segment,
            physician_qty: (segment_count && segment_count[seg.segment]) || 0,
            importance: seg.importance
        }));
    }
    return [];
};

export const createIntensityAndCount = (intensity_count, intensity_value = []) => {
    const intensity = [];
    if (intensity_value && intensity_value.length) {
        intensity_value.forEach(value => {
            let qty = 0;

            if (intensity_count) {
                qty =
                    intensity_count[
                        value['client_decile_importance']?.toLowerCase()
                    ]
                    ? intensity_count[
                            value['client_decile_importance']?.toLowerCase()
                      ][value['digital_affinity_importance']?.toLowerCase()]
                    : 0;
            }

            const updatedValue = {
                ...value,
                physician_qty: qty,
            };

            intensity.push(updatedValue);
        });
    } else {
        const importance = ['High', 'Medium', 'Low'];

        importance.forEach(val => {
            importance.forEach(ival => {
                let qty = 0;
                if (intensity_value && intensity_value.length > 0) {
                    qty =
                        (intensity_count[val?.toLowerCase()]
                            ? intensity_count[val?.toLowerCase()][
                                  ival?.toLowerCase()
                              ]
                            : 0) | 0;
                }

                intensity.push({
                    client_decile_importance: val,
                    digital_affinity_importance: ival,
                    physician_qty: qty,
                    digital_intensity: '',
                    promotion_intensity: '',
                });
            });
        });
    }

    return intensity;
};


export const { actions } = algorithmCampaign;
export default algorithmCampaign.reducer;
